'use strict';

/**
 * Sort of like a base class for all kinds of controllers.  Until we move to something like TypeScript
 * (which has real inheritance), invoke it on your controller instance:
 *
 * e.g.
 *
 * ControllerBase.call(this, utils);
 */
customerZone.factory('ControllerBase', ['$log', 'errorCode',
    function($log, errorCode){

        /** constructor function
         * @param endpoint endpoint url of the rest service to use
         * @constructor
         */
        var ControllerBase = function(utils) {

            /**
             * Handle uwa validation errors.  An error can continue multiple actual issues.  This function
             * will inspect the given error and compare it with a set of possible cases.  All matching cases are set
             * in this.uwaValidationErrors. If the function returns undefined, no errors were encountered.  Else,
             * the first matched error is returned.
             *
             * @param error the error to inspect.
             * @param knownCases An array of known cases, each having the fields:
             *          code: errorCode as listed in ErrorCode
             *          field: (optional) payload field uwa is complaining about
             *          on: field on the page to display an error on
             *          message: (optional) message to show to the user for this error (if omitted, code is used)
             * @param reporter: way to inform the user of issues (requires function showError). If omitted, utils is
             *        used.
             * @return the first matched issue if any.
             */
            this.handleValidationErrors = function(error, knownCases, reporter){
                var firstIssue = undefined;
                for (var i=0; i<knownCases.length; i++){
                    var knownCase = knownCases[i];
                    if (errorCode.is(error, knownCase.code, knownCase.field)) {
                        this.uwaValidationErrors[knownCase.on] = knownCase.message || knownCase.code;
                        firstIssue = firstIssue || knownCase;
                    }
                }
                if (firstIssue)
                    (reporter || utils).showError('there_are_still_errors_in_form');
                return firstIssue;
            };
        };

        return ControllerBase;
    }]);
